import { Modal, Button, message, Form, DatePicker, Checkbox } from 'antd';
import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { CloseActionBtn } from '../../lib/Resources';
import { storageService } from '../../lib/db/StorageService';
import { allAdminDataState, connectionAccountState } from '../../recoil/atoms';
import { Web3Service } from '../../lib/web3/Web3Service';
import { AdminSpecialDropData } from '../../lib/models/NftModel';
import { orderObject } from '../../lib/Utils';

export const AdminSpecialDropModal = ({
  visible,
  onCancel,
  drop,
}: {
  visible: boolean;
  onCancel: () => void;
  drop?: AdminSpecialDropData;
}) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const currentAccount = useRecoilValue(connectionAccountState);
  const [adminData, setAdminData] = useRecoilState(allAdminDataState);
  const [values, setValues] = useState<{
    deactivatedAt: any;
    collection: boolean;
    active: boolean;
  }>({
    deactivatedAt: drop.deactivatedAt,
    collection: drop.collection,
    active: drop.active,
  });

  useEffect(() => {
    setSubmitting(false);
  }, [drop]);

  async function onSubmit() {
    setSubmitting(true);

    const { connection } = window;
    const web3Service = new Web3Service(connection);
    const payload = {
      ...values,
      timestamp: moment().format(),
      walletAddress: currentAccount.address,
      action: 'update-drop',
    };
    const signData = JSON.stringify(orderObject(payload));
    const { signature } = await web3Service.signPersonalMessage(
      signData,
      currentAccount.address,
    );

    if (!signature) {
      message.warn(t('Error occurred while getting the signature'), 5);
      setSubmitting(false);
      return;
    }

    storageService
      .submitSpecialUpdate({
        dropID: drop.dropID,
        payload: {
          ...payload,
          signature,
        },
      })
      .then((res) => {
        if (res.drop) {
          setAdminData({
            ...adminData,
            drops: adminData.drops.map((dropData) => {
              if (dropData.id === res?.drop?.id) {
                return {
                  ...dropData,
                  ...res.drop,
                };
              }
              return dropData;
            }),
          });
        }

        if (res?.message) {
          message.success(res.message);
          onCancel();
        }

        if (res?.error) {
          message.success(res.error);
        }
      })
      .finally(() => setSubmitting(false));
  }

  const handleDateChange = (e) => {
    setValues({
      ...values,
      deactivatedAt: e.format(),
    });
  };

  const handleCheckboxInputChange = (e) => {
    const { checked, name } = e.target;
    setValues({
      ...values,
      [name]: checked,
    });
  };
  return (
    <Modal
      title=""
      visible={visible}
      centered
      onCancel={onCancel}
      footer={null}
      className="admin-confirmation-filter-modal"
      closeIcon={
        <div>
          <img src={CloseActionBtn} alt="Close action" height={20} width={20} />
        </div>
      }
    >
      <div className="admin-confirmation-title">Drop Details</div>

      <Form.Item label="Active">
        <Checkbox
          name="active"
          checked={values?.active}
          onChange={handleCheckboxInputChange}
        />
      </Form.Item>

      <Form.Item label="Collection">
        <Checkbox
          name="collection"
          checked={values?.collection}
          onChange={handleCheckboxInputChange}
        />
      </Form.Item>

      <Form.Item label="End Date">
        <DatePicker
          size="large"
          defaultValue={moment(drop?.deactivatedAt) as any}
          onChange={handleDateChange}
        />
      </Form.Item>

      <div className="admin-confirmation-bottom">
        <Button
          type="primary"
          className="nft-card-buy-button"
          loading={submitting}
          onClick={onSubmit}
        >
          {t('Update')}
        </Button>
      </div>
    </Modal>
  );
};
